import { t } from 'i18next';

import { FilterField, Position, Size } from 'coreOld/enums';
import { useGetCorporateUsersAutocomplete, useGetDisciplines } from 'corporate/hooks';
import { useGetLevels, useGetRequestStatuses } from 'support/hooks';

export const filtersConfig = () => [
  {
    name: 'query',
    type: FilterField.SEARCH,
    flex: 60,
    minWidth: 280,
    border: Position.LEFT,
    paddingLeft: 24,
    paddingRight: 24,
  },
  {
    name: 'disciplineId',
    type: FilterField.SELECT,
    props: {
      useGetOptions: useGetDisciplines,
      getValue: (opt) => opt?.id,
      getLabel: (opt) => opt?.name,
      placeholder: t('labelDisciplineSP'),
      isMulti: true,
    },
    border: Position.LEFT,
    paddingLeft: 24,
    minWidth: 100,
  },
  {
    name: 'statusId',
    type: FilterField.SELECT,
    props: {
      useGetOptions: useGetRequestStatuses,
      getValue: (opt) => opt?.id,
      getLabel: (opt) => opt?.name,
      placeholder: t('labelSupportRequestStatusSP'),
      isMulti: true,
    },
    minWidth: 100,
  },
  {
    name: 'levelId',
    type: FilterField.SELECT,
    props: {
      useGetOptions: useGetLevels,
      getValue: (opt) => opt?.id,
      getLabel: (opt) => opt?.name,
      placeholder: t('labelSupportRequestLevelSP'),
      isMulti: true,
    },
    minWidth: 100,
  },
  {
    name: 'externalLocationRegion',
    type: FilterField.TEXTFIELD,
    props: {
      placeholder: t('labelTheatre'),
      size: Size.LG,
    },
  },
  {
    name: 'externalLocationCountry',
    type: FilterField.TEXTFIELD,
    props: {
      placeholder: t('labelCountry'),
      size: Size.LG,
    },
  },
  {
    name: 'userId',
    type: FilterField.SELECT,
    props: {
      useGetOptions: useGetCorporateUsersAutocomplete,
      getValue: (opt) => opt?.userId,
      getLabel: (opt) => opt?.name,
      placeholder: t('labelCreatedByUser'),
      isMulti: true,
    },
    minWidth: 100,
    paddingRight: 24,
  },
  {
    name: 'add',
    type: FilterField.ADD,
    label: t('buttonLabelCreateNewSupportRequest'),
    flex: 10,
    height: 62,
    border: Position.LEFT,
    paddingLeft: 24,
    paddingRight: 24,
  },
];
